module.exports = __webpack_public_path__ + "static/media/sauce-pan-filled-with-cooked-food.7972e913.jpg";